import { render, staticRenderFns } from "./edit.html-blocks.page.vue?vue&type=template&id=7a76d552&"
import script from "./edit.html-blocks.page.vue?vue&type=script&lang=js&"
export * from "./edit.html-blocks.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports